import { ArrowLeftOutlined } from "@ant-design/icons"
import { Button, ConfigProvider } from "antd"
import { useNavigate } from "react-router-dom";

export const BackBtn = ({path,label}) => {
    const navigate = useNavigate();
    return (
        <Button type="link" icon={<ArrowLeftOutlined />} onClick={() => {navigate(path)}}>{label}</Button>
    )
}
export const CustomBtn = ({icon,label,onClick, color, colorHover, colorActive, colorText, htmlType='button'}) => {
    return (
        <ConfigProvider theme={{
            components: {
                Button: {
                    iconSize: 20,
                    colorPrimary: color,
                    colorPrimaryHover: colorHover,
                    colorPrimaryActive: colorActive,
                    colorPrimaryText: colorText,
                    colorText: colorText,
                    textTextColor: colorText,
                },
            },
        }}>
            <Button icon={icon} type="primary" onClick={onClick} htmlType={htmlType}>{label}</Button>
        </ConfigProvider>
    )
}
